<template>
  <div>
    <el-dialog
      title
      width="500px"
      class="repair-dialog"
      :visible.sync="hides"
      :before-close="handleClose"
    >
      <div class="dialog-mains p10">
        <el-image class="img" :src="notMoneyImg"></el-image>
        <p class="money fontSize20">很抱歉，您的账户余额不足</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-if="isYuanJian" class="btn" @click="topUp(1)">贵宾卡转入</el-button>
        <el-button type="primary" class="btn" @click="topUp(2)">立即充值</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import minxin from "../../assets/javascript/minxin.js";
export default {
  data() {
    return {
      hides: false,
      notMoneyImg: require("../../assets/images/new/insufficient.png"),
      memberId: '',
      mobile: '',
    };
  },
  props: {
    isYuanJian: {
      type: Boolean,
      default: false
    }
  },
  mixins: [minxin],
  components: {},
  created() {},
  mounted() {
    //this.getTableArr();
    this.topUpInit();
  },
  methods: {
    topUpInit() {
      this.$on("set", function(options) {
        this.hides = true;
        if (options) {
          if (typeof options === Object) {
            this.memberId = options.memberId;
            this.mobile = options.mobile;
          }else {
            this.memberId = options;
          }
        }
      });
    },
    handleClose() {
      this.hides = false;
      this.$emit("handleChange", false);
    },
    topUp(num) {
      // this.$router.push("/collectMoney/topUp");
      this.hides = false;
      if (num == 1) {
        this.$emit("handleChange", 'yuanjian');
      } else {
        console.log(1);
        this.$emit("handleChange", true);
      }
      
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/css/edit.less";
/deep/ .el-dialog {
  margin-top: 0 !important;
  height: 350px;
  top: calc(50% - 200px);
}
/deep/ .el-dialog__header {
  height: 50px;
  box-sizing: border-box;
  padding: 0;
  line-height: 50px;
  text-align: center;
  border: none !important;
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__headerbtn {
    top: 13px;
    .el-dialog__close {
      color: #666;
      border-radius: 50%;
      padding: 2px;
    }
  }
}
/deep/ .el-dialog__body {
  padding: 0.2rem 0;
  height: 190px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  .money {
    color: #333;
    font-weight: bold;
    text-align: center;
  }
  .dialog-mains {
    text-align: center;
    .img {
      margin-bottom: 40px;
    }
  }
}
/deep/ .el-dialog__footer {
  text-align: center;
  .btn {
    font-size: 16px;
    width: 155px;
    height: 55px;
  }
  .normal-btn {
    margin-right: 50px;
  }
}
</style>